<ion-header>
  <ion-toolbar>
    <ion-title>Export PDF Configuration</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-item>
    <ion-label>Paper Size:</ion-label>
    <ion-select placeholder="Select Paper Size" interface="popover" [(ngModel)]="selectedPaperSize">
      <ion-select-option value="A4">A4</ion-select-option>
      <ion-select-option value="A3">A3</ion-select-option>
      <ion-select-option value="LETTER">Letter</ion-select-option>
      <ion-select-option value="LEGAL">Legal</ion-select-option>
      <!-- Add more paper sizes as needed -->
    </ion-select>
  </ion-item>

  <ion-item>
    <ion-label>Page Orientation:</ion-label>
    <ion-select placeholder="Select Page Orientation" interface="popover" [(ngModel)]="selectedPageOrientation">
      <ion-select-option value="portrait">Portrait</ion-select-option>
      <ion-select-option value="landscape">Landscape</ion-select-option>
    </ion-select>
  </ion-item>

  <ion-item>
    <ion-label>Freeze Columns:</ion-label>
    <ion-input type="number" [(ngModel)]="numOfRefColumns"></ion-input>
  </ion-item>
  
  <ion-item>
    <ion-label>Max Column Content Length:</ion-label>
    <ion-input type="number" [(ngModel)]="maxColumnContentLength" placeholder="Enter max length"></ion-input>
  </ion-item>
  
  <ion-button expand="block" (click)="exportPdf()">Export</ion-button>
</ion-content>
